export const en = {
  'shell.nav.onboarding': 'Onboarding',
  'enum.checklistKind.ONBOARDING': 'Onboarding',
  'enum.checklistKind.OFFBOARDING': 'Offboarding',
  'enum.checklistAssignee.EMPLOYEE': 'Employee',
  'enum.checklistAssignee.MANAGER': 'Manager',
  'enum.checklistStatus.OPEN': 'In progress',
  'enum.checklistStatus.DONE': 'Done',
  'enum.checklistStatus.CANCELLED': 'Cancelled',
  'enum.checklistMatchRule.DEPARTMENT_ROLE': 'Department and role',
  'enum.checklistMatchRule.DEPARTMENT': 'Department',
  'enum.checklistMatchRule.ROLE': 'Role',
  'enum.checklistMatchRule.DEFAULT': 'Gym default',
  'enum.checklistMatchRule.MANUAL': 'Chosen by a manager',

  'onb.title': 'Onboarding',
  'onb.description': 'Checklists for people joining or leaving the team, and who has finished theirs.',
  'onb.tab.people': 'People',
  'onb.tab.templates': 'Templates',
  'onb.tab.employee': 'Onboarding',
  'onb.filter.status': 'Status',
  'onb.filter.statusAll': 'Any status',
  'onb.filter.kind': 'Kind',
  'onb.filter.kindAll': 'Onboarding and offboarding',
  'onb.filter.overdue': 'Overdue only',
  'onb.filter.clear': 'Clear filters',
  'onb.people.empty': 'Nobody has a checklist yet',
  'onb.people.emptyHint': 'A new employee gets one automatically when a template fits. You can also give one by hand from an employee’s page.',
  'onb.people.noMatch': 'No checklists match',
  'onb.people.noMatchHint': 'Try other filters.',
  'onb.progress': '{done} of {total} done',
  'onb.progressSkipped': '{done} of {total} done, {skipped} skipped',
  'onb.progressLabel': '{name}: {done} of {total} steps done',
  'onb.overdue.one': '1 step overdue',
  'onb.overdue.other': '{count} steps overdue',
  'onb.nextDue': 'Next due {date}',
  'onb.started': 'Counting from {date}',
  'onb.completedOn': 'Finished {date}',
  'onb.given.auto': 'Given automatically · {rule}',
  'onb.given.manual': 'Given by {name}',
  'onb.givenBy.manager': 'Given by a manager',

  'onb.templates.new': 'New template',
  'onb.templates.empty': 'No templates yet',
  'onb.templates.emptyHint': 'Write the steps once; every new employee the template fits gets their own copy.',
  'onb.templates.rule.default': 'Every employee',
  'onb.templates.rule.department': 'Department: {department}',
  'onb.templates.rule.role': 'Role: {role}',
  'onb.templates.rule.both': '{department} · {role}',
  'onb.templates.steps.one': '1 step',
  'onb.templates.steps.other': '{count} steps',
  'onb.templates.inUse.one': '1 person working through it',
  'onb.templates.inUse.other': '{count} people working through it',
  'onb.templates.off': 'Switched off',

  'onb.editor.new': 'New template',
  'onb.editor.edit': 'Edit template',
  'onb.editor.details': 'Who it is for',
  'onb.editor.name': 'Name',
  'onb.editor.nameRequired': 'Give the template a name in at least one language.',
  'onb.editor.kind': 'Kind',
  'onb.editor.department': 'Department',
  'onb.editor.anyDepartment': 'Any department',
  'onb.editor.role': 'Role',
  'onb.editor.anyRole': 'Any role',
  'onb.editor.ruleHint': 'A new employee gets the most specific template that fits: department and role together, then the department, then the role, then the one for every employee. Leave both empty for the gym default.',
  'onb.editor.active': 'Switched on',
  'onb.editor.activeHint': 'A template that is switched off is never given automatically.',
  'onb.editor.steps': 'Steps',
  'onb.editor.stepsHint': 'Changing the steps does not change checklists people already have.',
  'onb.editor.addStep': 'Add a step',
  'onb.editor.noSteps': 'No steps yet',
  'onb.editor.stepTitle': 'Step',
  'onb.editor.stepNumber': 'Step {number}',
  'onb.editor.stepTitleRequired': 'Write the step in at least one language.',
  'onb.editor.who': 'Done by',
  'onb.editor.article': 'Knowledge base article',
  'onb.editor.noArticle': 'No article',
  'onb.editor.dueAfter': 'Due after (days)',
  'onb.editor.dueAfterHint': 'Counted from the day the checklist starts. Leave empty for no due date.',
  'onb.editor.moveUp': 'Move step up',
  'onb.editor.moveDown': 'Move step down',
  'onb.editor.removeStep': 'Remove step',
  'onb.editor.unsaved': 'Unsaved changes',
  'onb.editor.save': 'Save template',
  'onb.editor.created': 'Template saved',
  'onb.editor.saved': 'Template saved',
  'onb.editor.delete': 'Delete template',
  'onb.editor.deleteTitle': 'Delete this template?',
  'onb.editor.deleteDescription': 'Checklists people already have stay as they are. New employees will no longer get this one.',
  'onb.editor.deleted': 'Template deleted',

  'onb.employee.title': '{name}: checklists',
  'onb.employee.empty': 'No checklist yet',
  'onb.employee.emptyHint': 'A new employee gets one when a template fits. You can give one now.',
  'onb.assign': 'Give a checklist',
  'onb.assign.title': 'Give {name} a checklist',
  'onb.assign.template': 'Template',
  'onb.assign.choose': 'Choose a template',
  'onb.assign.startsOn': 'Counting from',
  'onb.assign.startsOnHint': 'Due dates count from this day. Onboarding starts from the employee’s first day, offboarding from today.',
  'onb.assign.submit': 'Give checklist',
  'onb.assign.none': 'No active template has steps yet. Write one under Team → Onboarding → Templates.',
  'onb.assigned': 'Checklist given',
  'onb.startOffboarding': 'Start offboarding',
  'onb.offboarding.title': 'Start offboarding for {name}?',
  'onb.offboarding.description': 'They get the offboarding checklist: return the card, close access and the rest. Nothing is switched off automatically.',
  'onb.offboarding.confirm': 'Start offboarding',
  'onb.cancel': 'Cancel checklist',
  'onb.cancel.title': 'Cancel this checklist?',
  'onb.cancel.description': 'It stops counting and nobody is reminded about it. What was ticked stays on record.',
  'onb.cancelled': 'Checklist cancelled',

  'onb.step.due': 'Due {date}',
  'onb.step.overdue': 'Overdue · was due {date}',
  'onb.step.doneBy': 'Done by {name}, {date}',
  'onb.step.doneOn': 'Done {date}',
  'onb.step.skipped': 'Skipped: {reason}',
  'onb.step.waitingManager': 'Waiting for a manager',
  'onb.step.tick': 'Mark “{title}” as done',
  'onb.step.untick': 'Mark “{title}” as not done',
  'onb.step.skip': 'Skip',
  'onb.step.unskip': 'Take the skip back',
  'onb.step.article': 'Open article',
  'onb.skip.title': 'Skip this step?',
  'onb.skip.reason': 'Why does it not apply?',
  'onb.skip.confirm': 'Skip step',

  'onb.mine.title': 'My onboarding',
  'onb.mine.titleOff': 'My offboarding',
  'onb.mine.allMine': 'All your steps are done. The rest is for a manager.',
  'onb.mine.showDone': 'Show finished steps',
  'onb.mine.hideDone': 'Hide finished steps',

  'admin.apiError.CHECKLIST_MANAGER_ITEM': 'This step is for a manager to do.',
  'admin.apiError.CHECKLIST_RULE_TAKEN': 'An active template of this kind already covers that department and role.',
  'admin.apiError.CHECKLIST_ALREADY_OPEN': 'This person is already working through that checklist.',
  'admin.apiError.NO_MATCHING_TEMPLATE': 'No active template fits this person. Choose one.',
  'admin.apiError.CHECKLIST_TEMPLATE_EMPTY': 'Add steps to this template first.',
  'admin.apiError.CHECKLIST_TEMPLATE_INACTIVE': 'That template is switched off.',
  'admin.apiError.CHECKLIST_CANCELLED': 'This checklist was cancelled.',
  'admin.apiError.CHECKLIST_NOT_OPEN': 'Only a checklist that is still open can be cancelled.',
  'admin.apiError.CHECKLIST_ITEM_SKIPPED': 'Take the skip back before marking this step done.',
  'admin.apiError.CHECKLIST_ITEM_NOT_PENDING': 'Only a step that is still waiting can be skipped.',
  'admin.apiError.ONBOARDING_SETUP_GYM_WIDE': 'Templates are set up by someone who works at every branch.',
  'admin.apiError.UNKNOWN_ARTICLE': 'A step links to an article that is not in the knowledge base.',
  'admin.apiError.UNKNOWN_DEPARTMENT': 'That department is not at this gym.',
  'admin.apiError.DEPARTMENT_HAS_CHECKLISTS': 'Move or delete this department’s onboarding templates first.',
};

export const ka: Record<keyof typeof en, string> = {
  'shell.nav.onboarding': 'ადაპტაცია',
  'enum.checklistKind.ONBOARDING': 'ადაპტაცია',
  'enum.checklistKind.OFFBOARDING': 'გასვლა',
  'enum.checklistAssignee.EMPLOYEE': 'თანამშრომელი',
  'enum.checklistAssignee.MANAGER': 'მენეჯერი',
  'enum.checklistStatus.OPEN': 'მიმდინარეობს',
  'enum.checklistStatus.DONE': 'დასრულებულია',
  'enum.checklistStatus.CANCELLED': 'გაუქმებულია',
  'enum.checklistMatchRule.DEPARTMENT_ROLE': 'განყოფილება და როლი',
  'enum.checklistMatchRule.DEPARTMENT': 'განყოფილება',
  'enum.checklistMatchRule.ROLE': 'როლი',
  'enum.checklistMatchRule.DEFAULT': 'დარბაზის ნაგულისხმევი',
  'enum.checklistMatchRule.MANUAL': 'მენეჯერის არჩევით',

  'onb.title': 'ადაპტაცია',
  'onb.description': 'ჩამონათვალი გუნდში შემოსული ან გასული ადამიანებისთვის და ის, ვინ რამდენი დაასრულა.',
  'onb.tab.people': 'ადამიანები',
  'onb.tab.templates': 'შაბლონები',
  'onb.tab.employee': 'ადაპტაცია',
  'onb.filter.status': 'სტატუსი',
  'onb.filter.statusAll': 'ნებისმიერი სტატუსი',
  'onb.filter.kind': 'ტიპი',
  'onb.filter.kindAll': 'ადაპტაცია და გასვლა',
  'onb.filter.overdue': 'მხოლოდ ვადაგადაცილებული',
  'onb.filter.clear': 'ფილტრების გასუფთავება',
  'onb.people.empty': 'ჯერ არავის აქვს ჩამონათვალი',
  'onb.people.emptyHint': 'ახალ თანამშრომელს ჩამონათვალი ავტომატურად ეძლევა, თუ შესაბამისი შაბლონია. შეგიძლიათ ხელითაც მისცეთ თანამშრომლის გვერდიდან.',
  'onb.people.noMatch': 'ჩამონათვალი ვერ მოიძებნა',
  'onb.people.noMatchHint': 'სცადეთ სხვა ფილტრები.',
  'onb.progress': '{done} / {total} შესრულებულია',
  'onb.progressSkipped': '{done} / {total} შესრულებულია, {skipped} გამოტოვებულია',
  'onb.progressLabel': '{name}: {done} / {total} ნაბიჯი შესრულებულია',
  'onb.overdue.one': '1 ნაბიჯი ვადაგადაცილებულია',
  'onb.overdue.other': '{count} ნაბიჯი ვადაგადაცილებულია',
  'onb.nextDue': 'უახლოესი ვადა: {date}',
  'onb.started': 'ათვლის დღე: {date}',
  'onb.completedOn': 'დასრულდა {date}',
  'onb.given.auto': 'მიენიჭა ავტომატურად · {rule}',
  'onb.given.manual': 'მიანიჭა: {name}',
  'onb.givenBy.manager': 'მიანიჭა მენეჯერმა',

  'onb.templates.new': 'ახალი შაბლონი',
  'onb.templates.empty': 'შაბლონები ჯერ არ არის',
  'onb.templates.emptyHint': 'ნაბიჯები ერთხელ ჩაწერეთ; ყველა ახალი თანამშრომელი, ვისაც შაბლონი ერგება, თავის ასლს მიიღებს.',
  'onb.templates.rule.default': 'ყველა თანამშრომელი',
  'onb.templates.rule.department': 'განყოფილება: {department}',
  'onb.templates.rule.role': 'როლი: {role}',
  'onb.templates.rule.both': '{department} · {role}',
  'onb.templates.steps.one': '1 ნაბიჯი',
  'onb.templates.steps.other': '{count} ნაბიჯი',
  'onb.templates.inUse.one': '1 ადამიანი გადის',
  'onb.templates.inUse.other': '{count} ადამიანი გადის',
  'onb.templates.off': 'გამორთულია',

  'onb.editor.new': 'ახალი შაბლონი',
  'onb.editor.edit': 'შაბლონის რედაქტირება',
  'onb.editor.details': 'ვისთვისაა',
  'onb.editor.name': 'სახელი',
  'onb.editor.nameRequired': 'მიუთითეთ შაბლონის სახელი მინიმუმ ერთ ენაზე.',
  'onb.editor.kind': 'ტიპი',
  'onb.editor.department': 'განყოფილება',
  'onb.editor.anyDepartment': 'ნებისმიერი განყოფილება',
  'onb.editor.role': 'როლი',
  'onb.editor.anyRole': 'ნებისმიერი როლი',
  'onb.editor.ruleHint': 'ახალი თანამშრომელი იღებს ყველაზე შესაბამის შაბლონს: ჯერ განყოფილება და როლი ერთად, შემდეგ განყოფილება, შემდეგ როლი, ბოლოს — ყველა თანამშრომლისთვის განკუთვნილი. ორივე ველის ცარიელად დატოვებით შაბლონი დარბაზის ნაგულისხმევი ხდება.',
  'onb.editor.active': 'ჩართულია',
  'onb.editor.activeHint': 'გამორთული შაბლონი ავტომატურად არავის ეძლევა.',
  'onb.editor.steps': 'ნაბიჯები',
  'onb.editor.stepsHint': 'ნაბიჯების შეცვლა იმ ჩამონათვალს არ ცვლის, რომელიც ადამიანებს უკვე აქვთ.',
  'onb.editor.addStep': 'ნაბიჯის დამატება',
  'onb.editor.noSteps': 'ნაბიჯები ჯერ არ არის',
  'onb.editor.stepTitle': 'ნაბიჯი',
  'onb.editor.stepNumber': 'ნაბიჯი {number}',
  'onb.editor.stepTitleRequired': 'ჩაწერეთ ნაბიჯი მინიმუმ ერთ ენაზე.',
  'onb.editor.who': 'ასრულებს',
  'onb.editor.article': 'ცოდნის ბაზის სტატია',
  'onb.editor.noArticle': 'სტატიის გარეშე',
  'onb.editor.dueAfter': 'ვადა (დღეებში)',
  'onb.editor.dueAfterHint': 'ითვლება ჩამონათვალის დაწყების დღიდან. ვადის გარეშე დატოვეთ ცარიელი.',
  'onb.editor.moveUp': 'ნაბიჯის ზემოთ აწევა',
  'onb.editor.moveDown': 'ნაბიჯის ქვემოთ დაწევა',
  'onb.editor.removeStep': 'ნაბიჯის წაშლა',
  'onb.editor.unsaved': 'შეუნახავი ცვლილებები',
  'onb.editor.save': 'შაბლონის შენახვა',
  'onb.editor.created': 'შაბლონი შენახულია',
  'onb.editor.saved': 'შაბლონი შენახულია',
  'onb.editor.delete': 'შაბლონის წაშლა',
  'onb.editor.deleteTitle': 'წაიშალოს ეს შაბლონი?',
  'onb.editor.deleteDescription': 'ჩამონათვალი, რომელიც ადამიანებს უკვე აქვთ, უცვლელი დარჩება. ახალ თანამშრომლებს ეს შაბლონი აღარ მიეცემათ.',
  'onb.editor.deleted': 'შაბლონი წაშლილია',

  'onb.employee.title': '{name}: ჩამონათვალი',
  'onb.employee.empty': 'ჩამონათვალი ჯერ არ არის',
  'onb.employee.emptyHint': 'ახალ თანამშრომელს ჩამონათვალი ეძლევა, თუ შესაბამისი შაბლონია. ახლაც შეგიძლიათ მიანიჭოთ.',
  'onb.assign': 'ჩამონათვალის მინიჭება',
  'onb.assign.title': 'მიანიჭეთ ჩამონათვალი: {name}',
  'onb.assign.template': 'შაბლონი',
  'onb.assign.choose': 'აირჩიეთ შაბლონი',
  'onb.assign.startsOn': 'ათვლის დღე',
  'onb.assign.startsOnHint': 'ვადები ამ დღიდან ითვლება. ადაპტაცია იწყება თანამშრომლის პირველი დღიდან, გასვლა — დღევანდელიდან.',
  'onb.assign.submit': 'ჩამონათვალის მინიჭება',
  'onb.assign.none': 'ნაბიჯებიანი აქტიური შაბლონი ჯერ არ არის. ჩაწერეთ: გუნდი → ადაპტაცია → შაბლონები.',
  'onb.assigned': 'ჩამონათვალი მინიჭებულია',
  'onb.startOffboarding': 'გასვლის დაწყება',
  'onb.offboarding.title': 'დაიწყოს გასვლის პროცესი: {name}?',
  'onb.offboarding.description': 'თანამშრომელი მიიღებს გასვლის ჩამონათვალს: ბარათის დაბრუნება, წვდომის დახურვა და სხვა. არაფერი ავტომატურად არ გამოირთვება.',
  'onb.offboarding.confirm': 'გასვლის დაწყება',
  'onb.cancel': 'ჩამონათვალის გაუქმება',
  'onb.cancel.title': 'გაუქმდეს ეს ჩამონათვალი?',
  'onb.cancel.description': 'ათვლა შეწყდება და შეხსენებები აღარ გაიგზავნება. რაც მონიშნული იყო, ჩანაწერებში დარჩება.',
  'onb.cancelled': 'ჩამონათვალი გაუქმებულია',

  'onb.step.due': 'ვადა: {date}',
  'onb.step.overdue': 'ვადაგადაცილებულია · ვადა იყო {date}',
  'onb.step.doneBy': 'შეასრულა: {name}, {date}',
  'onb.step.doneOn': 'შესრულდა {date}',
  'onb.step.skipped': 'გამოტოვებულია: {reason}',
  'onb.step.waitingManager': 'ელოდება მენეჯერს',
  'onb.step.tick': 'მონიშნეთ შესრულებულად: „{title}“',
  'onb.step.untick': 'მონიშვნის გაუქმება: „{title}“',
  'onb.step.skip': 'გამოტოვება',
  'onb.step.unskip': 'გამოტოვების გაუქმება',
  'onb.step.article': 'სტატიის გახსნა',
  'onb.skip.title': 'გამოტოვდეს ეს ნაბიჯი?',
  'onb.skip.reason': 'რატომ არ ეხება?',
  'onb.skip.confirm': 'ნაბიჯის გამოტოვება',

  'onb.mine.title': 'ჩემი ადაპტაცია',
  'onb.mine.titleOff': 'ჩემი გასვლა',
  'onb.mine.allMine': 'თქვენი ყველა ნაბიჯი შესრულებულია. დანარჩენი მენეჯერზეა.',
  'onb.mine.showDone': 'შესრულებული ნაბიჯების ჩვენება',
  'onb.mine.hideDone': 'შესრულებული ნაბიჯების დამალვა',

  'admin.apiError.CHECKLIST_MANAGER_ITEM': 'ეს ნაბიჯი მენეჯერმა უნდა შეასრულოს.',
  'admin.apiError.CHECKLIST_RULE_TAKEN': 'ამ ტიპის აქტიური შაბლონი ამ განყოფილებასა და როლს უკვე ფარავს.',
  'admin.apiError.CHECKLIST_ALREADY_OPEN': 'ეს ადამიანი ამ ჩამონათვალს უკვე გადის.',
  'admin.apiError.NO_MATCHING_TEMPLATE': 'ამ ადამიანს აქტიური შაბლონი არ ერგება. აირჩიეთ ხელით.',
  'admin.apiError.CHECKLIST_TEMPLATE_EMPTY': 'ჯერ დაამატეთ ამ შაბლონს ნაბიჯები.',
  'admin.apiError.CHECKLIST_TEMPLATE_INACTIVE': 'ეს შაბლონი გამორთულია.',
  'admin.apiError.CHECKLIST_CANCELLED': 'ეს ჩამონათვალი გაუქმებულია.',
  'admin.apiError.CHECKLIST_NOT_OPEN': 'გაუქმდება მხოლოდ ის ჩამონათვალი, რომელიც ჯერ კიდევ მიმდინარეობს.',
  'admin.apiError.CHECKLIST_ITEM_SKIPPED': 'ნაბიჯის შესრულებულად მონიშვნამდე გააუქმეთ გამოტოვება.',
  'admin.apiError.CHECKLIST_ITEM_NOT_PENDING': 'გამოტოვდება მხოლოდ ის ნაბიჯი, რომელიც ჯერ შესრულებული არ არის.',
  'admin.apiError.ONBOARDING_SETUP_GYM_WIDE': 'შაბლონებს აწყობს ადამიანი, რომელიც ყველა ფილიალში მუშაობს.',
  'admin.apiError.UNKNOWN_ARTICLE': 'ერთ-ერთი ნაბიჯი ისეთ სტატიას უკავშირდება, რომელიც ცოდნის ბაზაში არ არის.',
  'admin.apiError.UNKNOWN_DEPARTMENT': 'ეს განყოფილება ამ დარბაზში არ არსებობს.',
  'admin.apiError.DEPARTMENT_HAS_CHECKLISTS': 'ჯერ გადაიტანეთ ან წაშალეთ ამ განყოფილების ადაპტაციის შაბლონები.',
};
